export enum AuthenticationRoute {
    Login = '/login',
    UserPassword = '/login/user-password',
    PinCode = '/login/pin-code',
    NotAllowed = '/login/not-allowed',
    Forbidden = '/page-forbidden',
    NotFound = '/page-not-found',
}
